import React from "react";
import { Link } from "react-router-dom";

export default function LandingPage() {
  return (
    <div className="bg-white">
      {/* Navigation */}
      <nav className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
<div className="max-w-7xl mx-auto px-4 py-4">
  <div className="flex justify-between items-center gap-4">

    {/* Title */}
    <Link to="/" className="shrink-0">
      <h1 className="text-2xl font-bold whitespace-nowrap text-transparent bg-clip-text bg-gradient-to-r from-emerald-600 to-green-500 cursor-pointer">
        PickSlate
      </h1>
    </Link>

    {/* Buttons */}
    <div className="flex gap-3">
      <Link
        to="/login"
        className="px-4 py-2.5 text-gray-700 font-semibold hover:text-emerald-600 transition whitespace-nowrap"
      >
        Sign In
      </Link>

      <Link
        to="/signup"
        className="btn-primary px-4 py-2.5 text-white rounded-lg font-semibold shadow-md whitespace-nowrap"
      >
        Get Started
      </Link>
    </div>

  </div>
</div>

      </nav>

      {/* Hero Section */}
      <section className="gradient-bg text-white py-24">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h2 className="text-6xl font-bold mb-6">
            Compete with Friends.<br />
            Predict, Strategize, Win.
          </h2>
          <p className="text-2xl text-emerald-100 mb-10 max-w-3xl mx-auto">
            PickSlate is a season-long sports prediction league where you pick game winners and top-performing players across multiple sports. Track standings, face new opponents each week, and see who really knows their sports.
          </p>
          <div className="flex gap-4 justify-center">
            <Link
              to="/signup"
              className="bg-white text-emerald-600 px-10 py-5 rounded-xl font-bold text-lg shadow-xl hover:shadow-2xl transition transform hover:-translate-y-1"
            >
              Start a League Free
            </Link>
            <a
              href="#features"
              className="bg-white/10 backdrop-blur text-white px-10 py-5 rounded-xl font-bold text-lg border-2 border-white/30 hover:bg-white/20 transition"
            >
              Learn More
            </a>
          </div>

          <div className="mt-16 flex justify-center gap-12 text-center">
            <div>
              <div className="text-4xl font-bold">Free</div>
              <div className="text-emerald-200 text-sm">Forever</div>
            </div>
            <div>
              <div className="text-4xl font-bold">6+</div>
              <div className="text-emerald-200 text-sm">Sports Covered</div>
            </div>
            <div>
              <div className="text-4xl font-bold">Season</div>
              <div className="text-emerald-200 text-sm">2-16 Weeks</div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-gray-900 mb-4">
              Everything You Need to Compete
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Simple, social, and strategic tools to run season-long leagues with friends.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                emoji: "🏆",
                title: "Season-Long Leagues",
                desc: "Leagues last 2–16 weeks, with head-to-head matchups and cumulative standings that track your performance all season.",
              },
              {
                emoji: "⚔️",
                title: "Head-to-Head Matchups",
                desc: "Face a new opponent each week. Earn points for correct picks and matchup wins to climb your league standings.",
              },
              {
                emoji: "🎯",
                title: "Multi-Sport Play",
                desc: "Pick winners and top-performing players across NFL, NBA, MLB, NHL, and more — all in one league.",
              },
              {
                emoji: "📝",
                title: "Custom Slates",
                desc: "League commissioners can choose which games and players are eligible each week for maximum strategy and fun.",
              },
              {
                emoji: "📱",
                title: "Mobile First",
                desc: "Make picks, track standings, and follow matchups from anywhere with a clean, responsive interface.",
              },
              {
                emoji: "🤝",
                title: "Social & Competitive",
                desc: "Compete with friends, see who’s on top, and build rivalries. Optional prize pools handled outside the app.",
              },
            ].map((feature, i) => (
              <div
                key={i}
                className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 card-hover transition-all"
              >
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-emerald-600 to-green-500 flex items-center justify-center text-3xl mb-6 shadow-lg">
                  {feature.emoji}
                </div>
                <h3 className="text-2xl font-bold mb-4 text-gray-900">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="gradient-bg text-white py-24">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-5xl font-bold mb-6">Ready to Start Your League?</h2>
          <p className="text-2xl text-emerald-100 mb-10">
            Create your first season in minutes and start competing with friends.
          </p>
          <Link
            to="/signup"
            className="inline-block bg-white text-emerald-600 px-12 py-5 rounded-xl font-bold text-xl shadow-2xl hover:shadow-3xl transition transform hover:-translate-y-1"
          >
            Create Free Account
          </Link>
          <p className="text-emerald-200 mt-6">
            No credit card required • Free forever
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-gray-400 text-sm">
            © 2026 PickSlate. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
